/**
 * MingleTiles Theme JavaScript
 * Handles mobile menu, cart functionality, and interactive elements
 */

// Mobile Menu Functions
function openMenu() {
  const nav = document.getElementById('HeaderNav');
  const overlay = document.getElementById('HeaderOverlay');
  
  if (nav && overlay) {
    nav.classList.add('header__nav--open');
    overlay.classList.add('header__overlay--visible');
    document.body.style.overflow = 'hidden';
  }
}

function closeMenu() {
  const nav = document.getElementById('HeaderNav');
  const overlay = document.getElementById('HeaderOverlay');
  
  if (nav && overlay) {
    nav.classList.remove('header__nav--open');
    overlay.classList.remove('header__overlay--visible');
    document.body.style.overflow = '';
    // Reset any open mobile dropdowns
    document.querySelectorAll('.header__menu-item--open').forEach(function(el) {
      el.classList.remove('header__menu-item--open');
    });
  }
}

// Close menu on escape key
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closeMenu();
  }
});

// Close menu when clicking on a menu link
// On mobile: regular links close the menu, dropdown parents toggle their submenu
document.addEventListener('DOMContentLoaded', function() {
  const menuLinks = document.querySelectorAll('.header__menu-link');
  menuLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
      if (window.innerWidth >= 990) return; // desktop handles via CSS hover

      var parentItem = link.closest('.header__menu-item');
      var isDropdown = parentItem && parentItem.classList.contains('header__menu-item--has-dropdown');

      if (isDropdown) {
        // Toggle the submenu open/closed — do NOT close the whole menu
        event.preventDefault();
        event.stopPropagation();
        var isOpen = parentItem.classList.contains('header__menu-item--open');
        // Close any other open dropdowns first
        document.querySelectorAll('.header__menu-item--open').forEach(function(el) {
          el.classList.remove('header__menu-item--open');
        });
        if (!isOpen) {
          parentItem.classList.add('header__menu-item--open');
        }
      } else {
        // Regular link — close the whole menu
        closeMenu();
      }
    });
  });

  // Submenu links always close the whole menu after navigating
  document.querySelectorAll('.header__submenu-link').forEach(function(link) {
    link.addEventListener('click', function() {
      if (window.innerWidth < 990) {
        closeMenu();
      }
    });
  });
});

// Smooth Scroll for Anchor Links
document.addEventListener('DOMContentLoaded', function() {
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  
  anchorLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
      const href = this.getAttribute('href');
      
      // Skip if it's just '#'
      if (href === '#') {
        event.preventDefault();
        return;
      }
      
      const target = document.querySelector(href);
      
      if (target) {
        event.preventDefault();
        const headerOffset = 100;
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
});

// Add to Cart Functionality
document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.getElementById('product-form');
  
  if (productForm) {
    productForm.addEventListener('submit', function(event) {
      event.preventDefault();
      
      const formData = new FormData(productForm);
      const submitButton = productForm.querySelector('button[type="submit"]');
      
      // Disable button and show loading state
      if (submitButton) {
        submitButton.classList.add('button--loading');
        submitButton.disabled = true;
      }
      
      // Convert FormData to JSON format Shopify expects
      const formDataObj = {};
      formData.forEach((value, key) => {
        formDataObj[key] = value;
      });
      
      // Debug: Log what we're sending
      console.log('Sending to cart:', formDataObj);
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formDataObj)
      })
      .then(response => {
        // Check if response is OK before parsing
        if (!response.ok) {
          return response.json().then(err => {
            throw new Error(JSON.stringify(err));
          });
        }
        return response.json();
      })
      .then(data => {
        console.log('Successfully added to cart:', data);
        
        // Update cart count
        updateCartCount();
        
        // Re-enable button
        if (submitButton) {
          submitButton.classList.remove('button--loading');
          submitButton.disabled = false;
        }
        
        // Redirect to cart page only on success
        window.location.href = '/cart';
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        console.error('Form data that was sent:', formDataObj);
        
        // Re-enable button
        if (submitButton) {
          submitButton.classList.remove('button--loading');
          submitButton.disabled = false;
        }
        
        // Show error to user
        alert('Error adding to cart. Check console for details.');
      });
    });
  }
});

// Update Cart Count
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('.header__cart-count');
      
      cartCountElements.forEach(function(element) {
        if (cart.item_count > 0) {
          element.textContent = cart.item_count;
          element.style.display = 'flex';
        } else {
          element.style.display = 'none';
        }
      });
    })
    .catch(error => {
      console.error('Error updating cart count:', error);
    });
}

// Lazy Load Images (for browsers that don't support native lazy loading)
document.addEventListener('DOMContentLoaded', function() {
  if ('loading' in HTMLImageElement.prototype) {
    // Browser supports native lazy loading
    return;
  }
  
  // Fallback for older browsers
  const lazyImages = document.querySelectorAll('img[loading="lazy"]');
  
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src || img.src;
          img.removeAttribute('loading');
          imageObserver.unobserve(img);
        }
      });
    });
    
    lazyImages.forEach(function(img) {
      imageObserver.observe(img);
    });
  } else {
    // Fallback for even older browsers - load all images immediately
    lazyImages.forEach(function(img) {
      img.src = img.dataset.src || img.src;
      img.removeAttribute('loading');
    });
  }
});

// Handle window resize for mobile menu
let resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    // Close mobile menu if window is resized to desktop
    if (window.innerWidth >= 990) {
      closeMenu();
    }
  }, 250);
});

// Shopify Theme Editor Support
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    console.log('Section loaded:', event.detail.sectionId);
  });
  
  document.addEventListener('shopify:section:unload', function(event) {
    console.log('Section unloaded:', event.detail.sectionId);
  });
  
  document.addEventListener('shopify:section:select', function(event) {
    console.log('Section selected:', event.detail.sectionId);
  });
  
  document.addEventListener('shopify:section:deselect', function(event) {
    console.log('Section deselected:', event.detail.sectionId);
  });
  
  document.addEventListener('shopify:block:select', function(event) {
    console.log('Block selected:', event.detail.blockId);
  });
  
  document.addEventListener('shopify:block:deselect', function(event) {
    console.log('Block deselected:', event.detail.blockId);
  });
}

// Initialize cart count on page load
document.addEventListener('DOMContentLoaded', function() {
  updateCartCount();
});

console.log('MingleTiles Theme JavaScript loaded successfully');
